import React from "react";

export const HeaderTitle = ({ children, className, id }) => {
  return (
    <div style={{ backgroundColor: "#2D333B" }} className={className} id={id}>
      {children}{" "}
    </div>
  );
};
